import { API_ENDPOINTS } from "./apiEndpoints";

const existsCache: Record<string, boolean> = {};

export async function fetchLineExists(
  id: string,
  signal?: AbortSignal
): Promise<boolean> {
  const key = String(id);
  if (key in existsCache) return existsCache[key];

  try {
    const res = await fetch(API_ENDPOINTS.LINES_DETAILS(key), { signal });
    if (!res.ok) {
      existsCache[key] = false;
      return false;
    }
    const json = await res.json();
    const exists = Array.isArray(json) && json.length > 0;
    existsCache[key] = exists;
    return exists;
  } catch {
    return false;
  }
}

export async function ensureLinesExist(
  ids: string[],
  opts: { concurrency?: number; signal?: AbortSignal } = {}
): Promise<Record<string, boolean>> {
  const unique = Array.from(new Set(ids.map(String)));
  const toCheck = unique.filter((id) => !(id in existsCache));
  const res: Record<string, boolean> = {};

  const concurrency = Math.min(
    opts.concurrency ?? 4,
    Math.max(1, toCheck.length)
  );
  let i = 0;

  async function worker() {
    while (i < toCheck.length) {
      const idx = i++;
      const id = toCheck[idx];
      const ok = await fetchLineExists(id, opts.signal);
      res[id] = ok;
    }
  }

  await Promise.all(Array.from({ length: concurrency }, () => worker()));

  for (const id of unique) {
    if (!(id in res) && id in existsCache) {
      res[id] = existsCache[id];
    }
  }
  return res;
}
